import { Instance } from 'mobx-state-tree';
import model from './model';

const TokenQueryStore = model;

export interface ITokenQueryStore extends Instance<typeof TokenQueryStore> {}

export default TokenQueryStore;
